export default __webpack_public_path__ + "static/media/graphic-guards-protector.7b6a45bd.glb";